module.exports = {
  path: 'terms_of_service',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/TermsOfService'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/more/routes/terms_of_service/index.js